// extracted by mini-css-extract-plugin
module.exports = {"icon":"Detail_icon__3308q"};